import { useState } from "react";
import DomainVerificationView from "./DomainVerification.view";
function DomainVerificationContainer(props) {
    const [verified, setVerified] = useState(false);
    return <DomainVerificationView verified={verified} />;
}

export default DomainVerificationContainer;
